import axios from "axios";
import { toBase64 } from "./misc";

let endpoint;

function setEndpoint(apiEndpoint) {
    endpoint = apiEndpoint;
}

async function sendContact(data) {
    if (data.settings.logo) {
        const logo = { name: data.settings.logo.name, data: await toBase64(data.settings.logo) };
        data.settings.logo = logo;
    }
    await axios.post(endpoint, data);
}

const token = 'api';
async function directusSendContactLogo(logo) {
    const formData = new FormData();
    formData.append('file', logo);
    const response = await axios.post(`${endpoint}/files?access_token=${token}`, formData);
    return response.data;
}

async function directusSendContact(data) {
    await axios.post(`${endpoint}/items/contact_panel?access_token=${token}`, data);
}

export default { setEndpoint, sendContact };